import RawOutput from './Contexts/RawOutput';

export default class CodeOutputFactory {

    constructor(palette, options = {}) {
        this.palette = palette;
        this.options = options;
    }


    make() {
        let lines = this.palette.swatches.map(swatch => this.buildLine(swatch));

        let output = new this.options.context(lines);

        return this.applyOptions(this.options.contextOptions, output, lines);
    }


    buildLine(swatch) {
        let format = this.buildFormat(swatch);

        let line = new this.options.context.line(swatch, format);

        return this.applyOptions(this.options.lineOptions, line, swatch);
    }

    buildFormat(swatch) {
        let format = new this.options.format(swatch);

        return this.applyOptions(this.options.formatOptions, format, swatch);
    }


    applyOptions(options, decorator, subject) {
        options.forEach(option => {
            decorator = new option(subject, decorator);
        });

        return decorator;
    }

}